import { createSelector } from 'reselect';

const reviewsStateSelector = (state) => state.reviews;

export const testimonialsSelector = createSelector(
  reviewsStateSelector,
  (reviews) => reviews.data.testimonials,
);

export const paginationSelector = createSelector(
  reviewsStateSelector,
  (reviews) => reviews.data.pagination,
);

export const loadingSelector = createSelector(
  reviewsStateSelector,
  (reviews) => reviews.loading,
);

export const qnaSelector = createSelector(
  reviewsStateSelector,
  (reviews) => ({
    isOpen: reviews.qnaModalOpen,
    askedToId: reviews.qnaAskedToId,
    questions: reviews.questions,
  }),
);

export const userDetailsSelector = createSelector(
  reviewsStateSelector,
  (reviews) => ({
    showMissingDetailsModal: reviews.showMissingDetailsModal,
    userDetails: reviews.userDetails,
  }),
);

export const requestParamsSelector = createSelector(
  reviewsStateSelector,
  (reviews) => ({
    quickFilters: reviews.quickFilters,
    search: reviews.search,
    advancedFilters: reviews.advancedFilters,
  }),
);

export const successModalSelector = createSelector(
  reviewsStateSelector,
  (reviews) => ({
    successModalOpen: reviews.successModalOpen,
  }),
);

export const fcSelector = createSelector(
  reviewsStateSelector,
  (reviews) => ({
    isFcRegisteredAlready: reviews.isFcRegisteredAlready,
    isFcRegistered: reviews.isFcRegistered,
    isFcRegistering: reviews.isFcRegistering,
    fcEventData: reviews.fcEventData,
    fcEventDataError: reviews.fcEventDataError,
    isFcModalOpen: reviews.isFcModalOpen,
  }),
);

export const personalisedModalSelector = createSelector(
  reviewsStateSelector,
  (reviews) => ({
    isPersonalisedModalOpen: reviews.isPersonalisationModalOpen,
  }),
);

export const profleSidebaSelector = createSelector(
  reviewsStateSelector,
  (reviews) => ({
    isProfileSidebarModalOpen: reviews.isProfileSidebarModalOpen,
  }),
);

export const signupSidebarSelector = createSelector(
  reviewsStateSelector,
  (reviews) => ({
    isSignupSideBarOpen: reviews.isSignupSideBarOpen,
  }),
);
